import React from 'react';
import './EncomendasTransformer.css'; // Use o mesmo arquivo CSS

const ExpandedRow = ({ produtor }) => {
  return (
    <div className="expanded-content">
      <div className="timeline">
        <div className="step">
          <div className="step-title">Produtor</div>
          <div className="step-content">
            <p><strong>3.2 Ton</strong></p>
            <p>Bolota de sobreiro</p>
            <p>50% Humidade</p>
            <p>30% Casca</p>
          </div>
        </div>
        <div className="step">
          <div className="step-title">Transformadora (secagem)</div>
          <div className="step-content">
            <p><strong>1.2 Ton</strong></p>
            <p>Polpa</p>
            <p>Granel</p>
          </div>
        </div>
        <div className="step">
          <div className="step-title">Transformadora (torra)</div>
          <div className="step-content">
            <p><strong>1.0 Ton</strong></p>
            <p>Polpa</p>
            <p>Granel (20% perda)</p>
            <p>embalagem (sacos 25kg)</p>
          </div>
        </div>
        <div className="step">
          <div className="step-title">Cliente</div>
          <div className="step-content">
            <p><strong>1.0 Ton</strong></p>
            <p>Infusão</p>
            <p>Sacos 250g</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandedRow;